import { FunctionComponent, useMemo, type JSX } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useSelector } from '@/api/state';
import { usePermissions } from '@/hooks/usePermissions';
import { Text } from '@payaca/ambrosia';
import { AnnouncementBanner } from '@payaca/components/announcementBanner/AnnouncementBanner';
import { AccountsPermissions } from '@payaca/permissions/accounts/accounts.permissions';
import { Link } from 'react-router-dom';
import { PermissionGuard } from '../permissionGuard/PermissionGuard';
import './TrialPeriodExpiryBanner.sass';

const TrialPeriodExpiryBanner: FunctionComponent = (): JSX.Element | null => {
  const history = useHistory();
  const location = useLocation();
  const { userHasRequiredPermission } = usePermissions();

  const currentUserFirstName: string = useSelector((state: any) => {
    return state.users.myProfile?.firstname;
  });

  const currentUserIsAdmin: boolean = useMemo(() => {
    return userHasRequiredPermission([AccountsPermissions.UPDATE_SUBSCRIPTION]);
  }, [userHasRequiredPermission]);

  const isOnManageSubscriptionPage = useMemo(() => {
    return location.pathname == '/upgradeAccount';
  }, [location]);

  return (
    <AnnouncementBanner>
      <div className="flex flex-row items-baseline gap-4">
        <div className="mr-auto">
          <Text>
            Hi {currentUserFirstName}, your trial period has expired.
            <PermissionGuard
              renderIfHasPermissions={[AccountsPermissions.UPDATE_SUBSCRIPTION]}
            >
              <> Contact your account administrator to subscribe.</>
            </PermissionGuard>
          </Text>
        </div>
        {!isOnManageSubscriptionPage && (
          <PermissionGuard
            renderIfHasPermissions={[AccountsPermissions.UPDATE_SUBSCRIPTION]}
          >
            <Link to="/upgradeAccount">
              <AnnouncementBanner.Button>
                Select your plan
              </AnnouncementBanner.Button>
            </Link>
          </PermissionGuard>
        )}
      </div>
    </AnnouncementBanner>
  );
};

export default TrialPeriodExpiryBanner;
